<template>
    <v-row>
        <v-col cols="12" md="6">
            <v-select
                :items="timestart_items"
                @change="timestartchange"
                item-text="txt"
                item-value="val"
                :label="$t('group_timestart')"
                dense
            >
            </v-select>
        </v-col>
        <v-col cols="12" md="6" >
            <v-select
                :items="timeend_items"
                @change="timeendchange"
                item-text="txt"
                item-value="val"
                :label="$t('group_timeend')"
                dense
            >
            </v-select>
        </v-col>
    </v-row>
</template>


<script>

    export default {
        props: {have_range_0: {type: Boolean,required: false,default: true}},
        data: () => ({
            timelist : [],
            timestart_items : [],
            timeend_items : [],

        }),
        mounted : function () {
            this.timelist = [0,30,100,130,200,230,300,330,400,430,500,530,600,630,700,730,800,830,900,930,1000,1030,1100,1130,1200,1230,1300,1330,1400,1430,1500,1530,1600,1630,1700,1730,1800,1830,1900,1930,2000,2030,2100,2130,2200,2230,2300,2330,2359]
            if(this.have_range_0) this.timelist = [-1].concat(this.timelist)
            this.timestart_items = this.timelistToItems(this.timelist)
            this.timeend_items = this.timelistToItems(this.timelist)
        },
        methods: {
            timelistToItems(timelist){
                return timelist.map(i=>{
                    if(i<0){
                        return {
                            txt : this.$i18n.t('select_time_all')
                            ,val : i
                        }
                        
                    }
                    var t = '0000' + i
                    return {
                        txt : t.substring(t.length-4,t.length-2) + ":" + t.substring(t.length-2,t.length)
                        ,val : i
                    }
                })
            },
            timestartchange(v){
                if(v<0){
                    this.timestart_items = this.timelistToItems(this.timelist)
                    this.timeend_items = this.timelistToItems(this.timelist)
                }else{
                    this.timeend_items = this.timelistToItems(this.timelist.filter(i=>i>v || i<0))
                }
                this.$emit('ontimestart', v)
            },
            timeendchange(v){
                if(v<0){
                    this.timestart_items = this.timelistToItems(this.timelist)
                    this.timeend_items = this.timelistToItems(this.timelist)
                }else{
                    this.timestart_items = this.timelistToItems(this.timelist.filter(i=>i<v || i<0))
                }
                this.$emit('ontimeend', v)
            }
        }
    }
</script>